import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "features/config/store";
import { ProcessActionCommittedDataParam } from "features/stock-ordering/core/stock-ordering.params";

interface InitialState {
  data: ProcessActionCommittedDataParam | undefined;
  status: boolean;
}

const initialState: InitialState = {
  data: undefined,
  status: false,
};

export const tableDataChangeSlice = createSlice({
  name: "tableDataChange",
  initialState,
  reducers: {
    tableDataChanged: (state, action) => {
      state.data = action.payload.data;
      state.status = true;
    },

    tableDataSave: (state) => {
      state.status = false;
    },

    resetTableDataChange: () => initialState,
  },
});

export const selectTableDataChange = (state: RootState) =>
  state.tableDataChange;

export const { tableDataChanged, tableDataSave, resetTableDataChange } =
  tableDataChangeSlice.actions;

export default tableDataChangeSlice.reducer;
